import { BaseMutationTypes } from '../BaseMutationTypes';

export class ThumbnailMutationTypes extends BaseMutationTypes {
  public static readonly AddThumbnail = 'ADD_THUMBNAIL';
  public static readonly RemoveThumbnailPagesForDocument = 'REMOVE_THUMBNAIL_PAGES_FOR_DOCUMENT';
  public static readonly ClearThumbnailCacheForDocument = 'CLEAR_THUMBNAIL_CACHE_FOR_DOCUMENT';
}
